
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import Config from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const isApp = ref<boolean>(false) // 是否在app内
        const msgDialogShow = ref<boolean>(false) // 是否在app内
        const correctTotal = ref<string>('')
        const message = ref<string>('')
        const imgUrl = ref<string>('')
        const posterShow = ref<boolean>(false)
        let isSubmiting = false

        const submit = () => {
            if (isSubmiting) return
            if (!message.value.trim()) {
                isSubmiting = false
                COVER.toast('请填写内容')
                return
            }
            isSubmiting = true
            let userInfo = $store.state.userInfo
            let token = userInfo.token || COVER.getDeviceId()
            _this.proxy.$request('/apply', {
                aid: $store.state.aid,
                info: {
                    message: message.value
                },
                token: token,
                userinfo: userInfo,
            }, 'post').then((res) => {
                COVER.toast('提交成功')
                setTimeout(() => {
                    message.value = ''
                    msgDialogShow.value = false
                    isSubmiting = false
                }, 2000)
            }).catch((res) => {
                isSubmiting = false
                if (res && res.errmsg) {
                    COVER.toast(res.errmsg)
                } else {
                    COVER.toast('提交失败，请重试')
                }
            })
        }

        const again = () => {
            $router.push('/')
        }

        const share = () => {
            if (imgUrl.value) {
                if (isApp.value) {
                    shareImage()
                } else {
                    posterShow.value = true
                }   
                return
            }
            $store.commit('SET_DIALOGDATA', {
                text: '分享图片生成中，请稍等...'
            })
            const c: HTMLCanvasElement = document.createElement('canvas')
            const ctx = c.getContext('2d') as CanvasRenderingContext2D
            Promise.all([_this.proxy.$common.onloadImg(require('../assets/img/share_bg.jpg'))]).then((imgs) => {
                c.width = imgs[0].width
                c.height = imgs[0].height
                ctx.drawImage(imgs[0], 0, 0, imgs[0].width, imgs[0].height, 0, 0, c.width, c.height)
                ctx.font = 'bold 200px Helvetica,Tahoma,Arial,"PingFang SC","Hiragino Sans GB","Heiti SC","Microsoft YaHei","WenQuanYi Micro Hei"'
                ctx.textBaseline = 'top'
                ctx.textAlign = 'center'
                ctx.fillStyle = '#e24d4d'
                ctx.fillText(correctTotal.value, c.width / 2, 912)
                ctx.strokeStyle = '#b83a3a'
                ctx.lineWidth = 8
                ctx.strokeText(correctTotal.value, c.width / 2, 912)
                imgUrl.value = c.toDataURL('image/jpeg')
                if (isApp.value) {
                    shareImage()
                } else {
                    posterShow.value = true
                }    
                $store.commit('SET_DIALOGDATA', null)
            }).catch(() => {
                _this.proxy.$common.toast('图片生成失败，请重试！')
                $store.commit('SET_DIALOGDATA', null)
            })
        }

        const shareImage = () => {
            COVERAPP.Method.shareImage({
                title: $store.state.shareData.title,
                desc: $store.state.shareData.desc,
                imgUrl: $store.state.shareData.imgUrl,
                link: $store.state.shareData.link,
                image: imgUrl.value.split(';base64,')[1],
                callback (ret: any) {
                    const data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret 
                    const origin = data.origin || ''
                    if (origin != 'None' && !_this.proxy.$common.isEmpty(origin)) {
                        _this.proxy.$common.track('share', '分享图片到' + origin)
                    } else {
                        _this.proxy.$common.track('share', '分享图片')
                    }
                }
            })
        }

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            correctTotal.value = sessionStorage.getItem('correctTotal') || ''
            COVER.pageLoaded()
            COVER.onshare($store.state.shareData)
        })    

        return {
            correctTotal,
            msgDialogShow,
            message,
            imgUrl,
            posterShow,
            submit,
            again,
            share
        }
    }
})
